<template>
  <v-alert
    color="primary"
    border="left"
    colored-border
    class="lg-results-msg elevation-1 body-2 pl-6 mb-0"
  >
    <div class="d-md-flex flex-md-nowrap align-md-baseline">
      <div
        v-if="status === 'success'"
        class="results-message flex-md-grow-1"
      >
        <p>
          Hi
          <b>{{ firstName }}</b>,
        </p>
        <p>
          We have searched our panel of specialist
          <b>{{ productTitleCapitalized }}</b>
          insurance providers and matched your requirements with the following
          {{ pluralize('company', resultsQty) }}.
        </p>
        <p v-if="!isOfficeHours">Although it is currently outside of office hours, they should aim to make contact with you as soon as possible.</p>
        <p v-if="isOfficeHours">
          Please look out for their
          {{ pluralize('call', resultsQty) }},
          as they should
          <template v-if="resultsQty > 1">each</template>
          be in contact shortly to provide a quote.
        </p>
        <p v-if="!isOfficeHours">
          Please look out for their
          {{ pluralize('call', resultsQty) }}
          <template v-if="resultsQty === 1">to receive their quote.</template>
          <template v-else>to compare their quotes and proceed with your preferred policy.</template>
        </p>
        <p v-if="isOfficeHours && resultsQty > 1">You can then compare their quotes and proceed with your preferred policy.</p>
      </div>
      <div
        v-if="status === 'resubmit'"
        class="results-message flex-md-grow-1"
      >
        <p>
          Sorry
          <b>{{ firstName }}</b>,
          we were unable to match you with any
          <b>{{ productTitleCapitalized }}</b>
          insurance providers.
        </p>
        <p>
          <strong>But wait! We may still be able to help you find insurance...</strong>
        </p>
        <p>
          As many of our insurance providers only offer quotations during their opening hours, you may have more success in being matched during these times.
        </p>

        <lg-results-resubmit
          :date-of-insurance-start="dateOfInsuranceStart"
          @resubmit="$emit('resubmit')"
        />
      </div>
      <div
        v-if="status === 'resubmitted'"
        class="results-message"
      >
        Thanks
        <b> {{ firstName }} </b>,
        we'll automatically run your quote details again at the time requested. If you're successfully matched, our partner insurance providers should be in touch directly to discuss your quotation.
      </div>
      <div
        v-if="status === 'empty'"
        class="results-message"
      >
        <p>
          Hi
          <b>{{ firstName }}</b>,
        </p>
        <p>
          Thank you for submitting your quotation request. Unfortunately, based on the details you've entered, we have been unable to match you with any of our
          <b>{{ productTitleCapitalized }}</b>
          insurance providers.
        </p>
      </div>
      <results-info-quote-ref
        :quote-ref="quoteRef"
      />
    </div>
  </v-alert>
</template>

<script>
import { capitalize } from 'lodash';
import pluralize from 'pluralize';
import LgResultsResubmit from './LgResultsResubmit.vue';
import ResultsInfoQuoteRef from '@/components/car/Results/ResultsInfoQuoteRef';
import { UtcDate } from '@/helpers/date';

export default {
  name: 'lg-results-msg',
  components: {
    ResultsInfoQuoteRef,
    LgResultsResubmit,
  },
  props: {
    quoteRef: {
      type: String,
      default: null,
    },
    productTitle: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      validate: val => ['success', 'empty', 'resubmit', 'resubmitted'].includes(val),
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    dateOfInsuranceStart: {
      type: String,
      required: true,
    },
    resultsQty: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      now: new UtcDate(),
    };
  },
  computed: {
    productTitleCapitalized () { return capitalize(this.productTitle); },
    isOfficeHours () {
      if (this.now.isSaturday() || this.now.isSunday()) return false;

      const hours = this.now.getHours();
      const mins = this.now.getMinutes();

      if (
        hours >= 7 &&
        (
          hours < 18 ||
          (hours === 18 && mins <= 29)
        )
      ) return true;
      return false;
    },
  },
  methods: {
    pluralize,
  },
};
</script>

<style lang="scss" scoped>
.lg-results-msg {
  p {
    margin: 0;
  }

  p + p { margin-top: 0.5em; }
}
</style>
